<template>
  <field-autocomplete
    v-bind="$attrs"
    v-model="iValue"
    :field="{}"
    :item-text="itemText"
    :item-value="itemValue"
    :remote="remote"
    :return-object="returnObject"
    cache-items
    custom-selection
    custom-item
    hide-selected
    v-on="$listeners"
  >
    <template #selection="data">
      <div class="v-select__selection v-select__selection--comma">
        <v-avatar
          v-if="initial(data.item)"
          color="primary"
          size="24"
        >
          <span class="white--text text-caption">
            {{ initial(data.item) | uppercase }}
          </span>
        </v-avatar>
        <span class="text--truncate ml-1">{{ getName(data.item) }}</span>
      </div>
    </template>
    <template #item="data">
      <v-avatar
        v-if="initial(data.item)"
        color="primary"
        size="30"
        class="mr-2"
      >
        <span class="white--text">
          {{ initial(data.item) | uppercase }}
        </span>
      </v-avatar>
      <v-list-item-content>
        <v-list-item-title v-html="getName(data.item)" />
      </v-list-item-content>
    </template>
  </field-autocomplete>
</template>

<script>
import FieldAutocomplete from '../FieldAutocomplete'

export default {
  name: 'FieldEntityTeam',
  components: {
    FieldAutocomplete
  },
  props: {
    itemText: {
      type: String,
      default: 'name'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Object, Number],
      default: null
    }
  },
  computed: {
    iValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    remote () {
      return {
        url: '/teams',
        urlFind: '/teams/:id',
        urlFindKey: 'id',
        method: 'GET',
        params: {
          searchParam: 'name'
        }
      }
    }
  },
  created () {
    this.$off('change')
  },
  methods: {
    getName (item) {
      return item.name ?? this.$t('common.undefined')
    },
    initial (item) {
      return item.name?.charAt(0)
    }
  }
}
</script>
